import "./SecretPage.style.css";

import skeleton from "../../resources/images/skeleton.mp4";
import { useRef, useState } from "react";
import {
  Button,
  ButtonColor,
  ButtonSize,
} from "../../components/base/Button/Button";
import { useNavigate } from "react-router-dom";
import { AppRouter } from "../../utils/enums/AppRouter";

export const SecretPage = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const navigate = useNavigate();

  const playVideo = () => {
    setShowVideo(true);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div className="secret-page">
      <span className="secret-page__caption">Стёпа, когда во Франк?</span>
      <Button
        className="secret-page__button"
        onClick={playVideo}
        text="Не сегодня."
        color={ButtonColor.Secondary}
        size={ButtonSize.Large}
      />
      <video
        className={`secret-page__video ${
          showVideo ? "" : "secret-page__video_hidden"
        }`}
        ref={videoRef}
        width="640"
        height="360"
        src={skeleton}
        onEnded={() => navigate(AppRouter.Main)}
      />
    </div>
  );
};
